<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-04-15 19:30:04
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-12-18 09:55:52
 * @FilePath: /wemeet-admin-new/src/views/enterPriseConfig/components/edit.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer"
    :direction="direction"
    :size="size"
    :title="title"
  >
    <el-drawer v-model="innerDrawer" :append-to-body="true" :before-close="handleCloseInner" :title="innerDrawertitle">
      <el-form v-if="innerDrawertitle == '修改有效期'" ref="formRef" :model="dateForm" :rules="rules">
        <el-form-item label="开始时间" prop="startDate">
          <el-input v-model="dateForm.startDate" disabled />
        </el-form-item>
        <el-form-item label="结束时间" prop="expireTime">
          <el-date-picker v-model="dateForm.expireTime" placeholder="选择结束时间" type="date" />
        </el-form-item>
        <el-form-item label="修改原因" prop="reason">
          <el-input v-model="dateForm.reason" placeholder="请填写原因" />
        </el-form-item>
      </el-form>

      <el-table v-else border :data="changeList">
        <el-table-column label="修改时间" prop="company">
          <template #default="{ row }">
            {{ handleDate(row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="修改后的有效期" prop="company">
          <template #default="{ row }">{{ row.oldData }} 至 {{ row.newData }}</template>
        </el-table-column>
        <el-table-column label="修改原因" prop="reason" />
      </el-table>

      <div v-if="innerDrawertitle == '修改有效期'" class="el-drawer__footer">
        <el-button type="primary" @click="upDateExpire">提交</el-button>
        <el-button @click="handleCloseInner">取消</el-button>
      </div>
    </el-drawer>

    <div class="containerForm">
      <el-descriptions border :column="1" direction="horizontal" :size="desSize" title="机构入驻信息">
        <!-- <el-descriptions-item label="订单编号">
          <span>{{ form.orderNo }}</span>
        </el-descriptions-item> -->
        <el-descriptions-item label="机构名称">
          <span>{{ form.enterpriseName }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="机构类型">
          <span>{{ form.enterpriseTypeName ? form.enterpriseTypeName : '/' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="请说明你和机构的关系">
          <span v-html="form.relations ? form.relations : '/'"></span>
        </el-descriptions-item>
        <el-descriptions-item label="请说明入驻机构的用途">
          <span v-html="form.description ? form.description : '/'"></span>
        </el-descriptions-item>
        <el-descriptions-item label="入驻时间">
          <span>{{ form.createTime }}</span>
        </el-descriptions-item>
        <!-- <el-descriptions-item label="支付方式">
          <span>
            {{
              form.payType == 'WECHAT_PAY'
                ? '微信支付'
                : form.payType == 'CORPORATE_TRANSFER'
                ? '对公转账'
                : '非盈利机构'
            }}
          </span>
        </el-descriptions-item> -->
        <!-- <el-descriptions-item label="交易流水号" v-if="form.payType == 'WECHAT_PAY'">
          <span>{{ form.outOrderNo }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="交易凭证" v-if="form.payType != 'WECHAT_PAY'">
          <el-image v-for="(item, index) in form.attachUrls" style="width: 100px; height: 100px" :src="item" :zoom-rate="1.2" :initial-index="4" fit="cover" :preview-src-list="[item]" />
        </el-descriptions-item> -->
        <!-- <el-descriptions-item label="提交时间">
          <span>{{ handleDate(form.orderTime) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="支付时间">
          <span>{{ form.payTime ? handleDate(form.payTime) : '暂无' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="有效期至">
          <span>
            {{
              form.payType == 'NON_PROFIT_ORG'
                ? '终身'
                : handleDate(form.expireTime, '{y}-{m}-{d}')
            }}
          </span>
          <div>
            <el-button type="success" @click="handleOpenInner('edit')" plain>
              修改有效期
            </el-button>
            <el-button type="success" @click="handleOpenInner('see')" plain>
              查看修改记录
            </el-button>
          </div>
        </el-descriptions-item> -->
        <div v-if="formStatus == 'SEE' || formStatus == 'MANAGAR'">
          <!-- <el-descriptions-item label="支付状态">
            <span>
              {{
                form.status == 'PAY_WAIT'
                  ? '待支付'
                  : form.status == 'PAY_OVER'
                  ? '已支付'
                  : form.status == 'PAY_CONFIRMED'
                  ? '支付待确认'
                  : form.status == 'PAY_NOT_PASS'
                  ? '支付被驳回'
                  : '支付取消'
              }}
            </span>
          </el-descriptions-item>
          <el-descriptions-item label="支付驳回原因">
            <span>
              {{ form.payReason }}
            </span>
          </el-descriptions-item>  -->

          <el-descriptions-item label="审核状态">
            <span>
              {{
                form.status == 'TRIAL'
                  ? '试用'
                  : form.status == 'PENDING_AUDIT'
                  ? '待审核'
                  : form.status == 'AUDIT_APPROVED'
                  ? '审核通过'
                  : form.status == 'REJECTED'
                  ? '审核驳回'
                  : form.status == 'ACTIVE'
                  ? '已启用'
                  : '已禁用'
              }}
            </span>
          </el-descriptions-item>
          <el-descriptions-item v-if="form.status == 'REJECTED'" label="审核不通过原因">
            <span>
              {{ form.reason }}
            </span>
          </el-descriptions-item>

          <el-descriptions-item label="平台内容发布协议">
            <span>{{ form.platformAgreementTime ? '已同意授权' + form.platformAgreementTime : '/' }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="机构入驻授权声明">
            <span>{{ form.enterpriseAgreementTime ? '已同意授权' + form.enterpriseAgreementTime : '/' }}</span>
          </el-descriptions-item>
        </div>

        <!-- <el-descriptions-item label="支付状态" v-if="form.formStatus == 'PAY'">
          <el-select v-model="payStatus.payStatus" class="m-2" placeholder="请选择支付状态">
            <el-option v-for="item in payStatusOption" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>

          <el-input placeholder="不通过原因" v-model="payStatus.reason" v-if="payStatus.payStatus == 'PAY_NOT_PASS'" style="margin-top: 5px"></el-input>
        </el-descriptions-item>-->

        <el-descriptions-item v-if="formStatus == 'AUDIT'" label="审核状态">
          <el-select v-model="auditStatus.status" class="m-2" placeholder="请选择审核状态">
            <el-option v-for="item in payStatusOption" :key="item.value1" :label="item.label" :value="item.value1" />
          </el-select>

          <el-input
            v-if="auditStatus.status == 'REJECTED'"
            v-model="auditStatus.reason"
            placeholder="不通过原因"
            style="margin-top: 5px"
          />
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions
        border
        :column="1"
        direction="horizontal"
        :size="desSize"
        style="margin-top: 10px"
        title="负责人信息"
      >
        <el-descriptions-item label="负责人姓名">
          <span>{{ form.name }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="负责人手机号">
          <span>{{ form.phone }}</span>
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions
        border
        :column="1"
        direction="horizontal"
        :size="desSize"
        style="margin-top: 10px"
        title="机构版本信息"
      >
        <el-descriptions-item label="当前生效版本">
          <span v-if="form.member == 'VIP'">{{ form.goodsName ? form.goodsName : '/' }}</span>
          <span v-else>机构基础会员</span>
        </el-descriptions-item>
        <el-descriptions-item label="当前生效订单">
          <div style="display: flex; justify-content: space-between">
            <span>{{ form.orderNo ? form.orderNo : '/' }}</span>
            <!-- <el-button plain type="success" v-if="form.orderNo" @click="handleGoOrder"> 查看订单</el-button> -->
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="会员生效时间">
          <span v-if="form.member == 'VIP'">{{ form.memberStartTime ? form.memberStartTime : '/' }}</span>
          <span v-else>{{ form.memberStartTime ? form.memberStartTime : '永久' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="会员到期时间">
          <span v-if="form.member == 'VIP'">{{ form.memberExpireTime ? form.memberExpireTime : '/' }}</span>
          <span v-else>{{ form.memberExpireTime ? form.memberExpireTime : '永久' }}</span>
          <!-- <div>
            <el-button type="success" @click="handleOpenInner('edit')" plain>
              修改有效期
            </el-button>
            <el-button type="success" @click="handleOpenInner('see')" plain>
              查看修改记录
            </el-button>
          </div> -->
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <div v-if="formStatus == 'AUDIT'" class="el-drawer__footer">
      <el-button type="primary" @click="save">提交</el-button>
      <el-button @click="handleClose">取消</el-button>
    </div>
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, toRefs } from 'vue'
  import {
    auditEnterPrise,
    updatePayStatus,
    updateExpireTime,
    getOrderExpireTimeHistory,
    enterpriseQueryDetail,
  } from '@/api/enterPriseApi'
  import { parseTime } from '@/utils/index'

  export default defineComponent({
    name: 'PageEdit',
    emits: ['fetch-data'],
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()

      const state = reactive({
        dialogFormVisible: false,
        innerDrawer: false,
        formRef: null,
        direction: 'rtl',
        size: '40%',
        title: '',
        form: {},
        formStatus: '',
        desSize: 'large',
        payStatusOption: [
          {
            label: '通过',
            value: 'PAY_OVER',
            value1: 'AUDIT_APPROVED',
          },
          {
            label: '不通过',
            value: 'PAY_NOT_PASS',
            value1: 'REJECTED',
          },
        ],
        payStatus: {
          reason: '',
        },
        auditStatus: {
          reason: '',
        },
        innerDrawertitle: '修改有效期',
        dateForm: {},
        changeList: [],
        rules: {
          reason: [
            {
              required: true,
              message: '请填写原因',
              trigger: 'blur',
            },
          ],
        },
      })

      const showEdit = async (row) => {
        state.formStatus = row.formStatus
        state.title = row.formStatus == 'SEE' ? '查看详情' : '审核'
        let { data } = await enterpriseQueryDetail(row.enterpriseCode, {
          eventKey: row.eventKey,
        })
        console.log(data, 'vasdasdasd')
        data.description = data.description ? data.description.replace(/\n/g, '<br>') : '/'
        data.relations = data.relations ? data.relations.replace(/\n/g, '<br>') : '/'
        state.form = data
        state.dialogFormVisible = true
        if (data.status != 'PENDING_AUDIT') {
          state.auditStatus.reason = data.reason
          state.auditStatus.status = data.status
        }
      }

      const handleClose = () => {
        state.form = {}
        state.dialogFormVisible = false
        state.auditStatus = {
          reason: '',
          status: '',
        }
      }

      const save = async () => {
        if (state.formStatus == 'AUDIT') {
          console.log(state.auditStatus.reason)
          if (state.auditStatus.status == 'REJECTED' && state.auditStatus.reason == '') {
            proxy.$baseMessage(`原因不能为空`, 'error', 'vab-hey-message-error')
            return false
          }
          state.auditStatus.enterpriseCode = state.form.enterpriseCode
          let data = await auditEnterPrise(state.auditStatus)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
          emit('fetch-data')
          handleClose()
        }
      }

      const handleDate = (date, format = '{y}-{m}-{d} {h}:{i}:{s}') => {
        return parseTime(date, format)
      }

      const handleCloseInner = () => {
        state.innerDrawer = false
      }

      const handleOpenInner = async (type) => {
        if (type == 'edit') {
          state.dateForm.startDate = parseTime(state.form.memberStartTime, '{y}-{m}-{d}')
          state.dateForm.expireTime = parseTime(state.form.memberExpireTime, '{y}-{m}-{d}')
          state.innerDrawertitle = '修改有效期'
          state.innerDrawer = true
        } else {
          let params = {
            orderNo: state.form.orderNo,
            pageNum: 1,
            pageSize: 9999,
          }
          const { data } = await getOrderExpireTimeHistory(params)
          console.log(data)
          state.changeList = data.list
          state.innerDrawertitle = '修改记录'
          state.innerDrawer = true
        }
      }

      const upDateExpire = async () => {
        state['formRef'].validate(async (valid) => {
          if (valid) {
            state.dateForm.orderNo = state.form.orderNo
            state.dateForm.expireTime = parseTime(state.dateForm.expireTime, '{y}-{m}-{d} {h}:{i}:{s}')
            const { data } = await updateExpireTime(state.dateForm)
            state.innerDrawer = false
            state.form.expireTime = state.dateForm.expireTime
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            emit('fetch-data')
          }
        })
      }

      const handleGoOrder = (row) => {
        proxy.$router.push({
          path: '/enterPriseConfig/enterpriseOrder',
          query: {
            enterpriseName: state.form.enterpriseName,
          },
        })
      }

      return {
        ...toRefs(state),
        showEdit,
        save,
        handleDate,
        handleClose,
        handleCloseInner,
        handleOpenInner,
        upDateExpire,
        handleGoOrder,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }
  .containerForm {
    height: 85vh;
    overflow: auto;
    padding-bottom: 100px;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }
  .el-drawer__footer {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: flex-end;
    z-index: $base-z-index + 1;
    padding: math.div($base-padding, 2);
    background: var(--el-color-white);
    border-top: 1px solid $base-border-color;
  }
</style>
